import AddAppointmentDialog from './AddAppointmentDialog';
export default AddAppointmentDialog;
